import React from 'react';
import { attributesType } from '../../components/libs/typeInterface';
import { WhatInIconArray } from '../../components/libs/WhatInIconArray';

interface IWhatIsIn {
  inside: attributesType[];
  product: string;
}

const WhatIsIn = (props: IWhatIsIn) => {
  const { inside, product } = props;

  const iconArray = WhatInIconArray('w-full');
  const filteredIcon = iconArray.filter((item) => item.name === product);

  return (
    <>
      <section className="xs:px-4 lg:px-0 relative w-full flex flex-col items-center justify-center lg:container lg:mx-auto lg:h-100">
        <div className="w-full h-full flex flex-col">
          <p className="font-breadley-sans xs:text-4xl lg:text-6xl text-customColors-300">
            What is in R&G <span className="capitalize">{product}</span>
          </p>
          <div className="xs:hidden w-full lg:h-full lg:flex flex-wrap items-start justify-between xs:py-5 lg:py-20 xs:space-y-5 lg:space-y-0">
            {inside?.map((item, index) => (
              <div
                key={index}
                className={
                  `w-1/2 flex` +
                  `${index === 0 || index === 2 ? ' items-start' : ' items-center'}` +
                  `${index % 2 === 1 ? ' justify-end' : ' justify-start'}`
                }
              >
                {item.value !== '' && (
                  <>
                    <div
                      className={
                        `w-12 flex items-start justify-center` + `${index === 1 ? ' h-3/5' : ''}`
                      }
                    >
                      {filteredIcon[index].icon}
                    </div>
                    <p className={`${index % 2 === 0 ? 'w-3/5' : ''} flex items-start ml-2 `}>
                      {item.value}
                    </p>
                  </>
                )}
              </div>
            ))}
          </div>

          <div className="w-full lg:h-full xs:flex lg:hidden flex-wrap items-start justify-between xs:py-5 lg:py-20 xs:space-y-5 lg:space-y-0">
            {inside?.map(
              (item, index) =>
                item.value !== '' && (
                  <div key={index} className="w-full flex lg:items-start justify-start flex-nowrap">
                    <div className="w-15 h-15 lg:w-20 lg:h-20 flex items-center lg:items-start justify-start">
                      <div className="xs:w-10 lg:w-14 flex items-end justify-start">
                        {filteredIcon[index].icon}
                      </div>
                    </div>
                    <p className="flex-1 flex xs:items-center lg:items-start ml-2">{item.value}</p>
                  </div>
                )
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default WhatIsIn;
